import React, { useEffect, useState } from "react";
import img from './r4.jpg';
import loadingimg from './loading_img.png';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import Header from "./Header";
import { getdata } from "../Api/api";
import './Firstpage.css'
import Middlesec from "./Middlesec";
import { useNavigate } from "react-router-dom";

function First_page() {

  var [n_obj,set_obj]=useState({});
  var navi=useNavigate();
  console.log(n_obj.Description,n_obj);
  var [state,setstate]=useState();
  async function caller() {
    const resp = await getdata();
    console.log(resp.data);
    setstate(resp.data);
    // console.log(state);
  }
  useEffect(()=>{
    caller();
    console.log("one");
  },[])
  
  return (
    <div className="container">
      <Header  />
      <Middlesec />
      <div className="last_div">
        <div className="rightbar">
          <div id="r_div">
            <img
              src={n_obj.imgurl ? n_obj.imgurl : img}
              style={{ width: "95%", minHeight: "60%", borderRadius: "20px" }}
            />{" "}
          </div>
          <div className="rightbarcontent">
            <div
              style={{
                justifyContent: "space-between",
                display: "flex",
                alignContent: "center",
                width: "95%",
                marginTop: "5px",
                marginBottom: "5px",
              }}
            >
              <h2
                onClick={() => {
                  console.log(Object.keys(n_obj).length);
                }}
                id="h_2rc"
              >
                {n_obj.Title ? n_obj.Title : "Default Blog"}
              </h2>
              {Object.keys(n_obj).length ? (
                <button onClick={(e)=>{
                  console.log(e.target.className, n_obj._id);
                  navi(`/edit/${n_obj._id}`);
                }}  className="btns_e" id="edit_btn">
                  Edit
                </button>
              ) : (
                ""
              )}
            </div>
            <p id="desc">
              {n_obj.Description
                ? n_obj.Description
                : "When you are in the market for a new vehicle, you likely want to find a car that has the most safety features to protect you in an accident. While safety technology can help you to prevent injuries, they may not be able to prevent all accidents from occurring. One feature of a vehicle that you might not think about when it comes to safety is the color of your vehicle. Most people choose the color of their cars based on how they look. You might want to think carefully about the color of the car that you choose, however. Researchers have found that the color of a vehicle is linked to its risk of being involved in a collision. If your vehicle is one of the riskier colors, it might increase your risk of being involved in an accident"}
            </p>
          </div>
        </div>
        <div className="leftbar">
          {state ? (
            state.map((e, i) => {
              // console.log(e.imgurl);

              return (
                <div
                  id="leftbar_ci"
                  onClick={() => {
                    // alert("hello user");
                    // console.log(e);
                    set_obj(e);
                  }}
                  className="data_"
                  key={i}
                >
                  {/* <img loading="lazy" id="data_img" placeholder="../r4.jpg"  src={process.env.PUBLIC_URL + './r4.jpg'} /> */}
                  <LazyLoadImage
                    id="data_img"
                    width="97%"
                    height="400px"
                    effect="blur"
                    // src={process.env.PUBLIC_URL + './r4.jpg'}
                    src={e.imgurl}
                    placeholderSrc={loadingimg}
                  />
                  <h1 id="data_h"> Title : {e.Title}</h1>
                  <DeleteOutlineIcon  onClick={()=>{
                    alert("hello ");
                  }}
                    style={{
                      display: "block",
                      color: "lightgreen",
                      fontSize: "32px",
                      position: "absolute",
                      bottom: "20",
                      right: "20",
                    }}
                  />
                </div>
              );
            })
          ) : (
            <div>
              <h1 style={{ textAlign: "center" }} id="data_h">
                {" "}
                Data wouldn't fetched check the Server or Refresh it.
              </h1>
              <br />
              <div>
                <img
                  style={{ background: "rgba(0,0,0,.3)" }}
                  width="97%"
                  height="400px"
                  border="1px solid black"
                />
              </div>
              <div>
                <img
                  style={{ background: "rgba(0,0,0,.3)" }}
                  width="97%"
                  height="400px"
                  border="1px solid black"
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default First_page;



// {
//   state
//     ? state.map((e, i) => {
//         return <div key={i}>1</div>;
//       })
//     : "not having";
// }